export default [
  { title: 'Your Org', url: '/manage/policies/org' },
  { title: 'Your Sites', url: '/manage/policies/sites' },
];
